export default __webpack_public_path__ + "static/media/logo12.65a8fe8d.jpg";